import { CKLayoutGrid } from 'clearkit';
import { Helmet } from 'react-helmet';

import { BannerUpgradePlan } from '~/components/CTABanner/BannerUpgradePlan';
import { HomeBannerConnectCRM } from '~/components/home/Banners';
import { HomeFooter } from '~/components/home/HomeFooter';
import { HomeHeader } from '~/components/home/HomeHeader';
import {
  HomeSectionCompanies,
  HomeSectionNotifications,
  HomeSectionOnboarding,
  HomeSectionTimePeriod,
} from '~/components/home/HomeSection';
import {
  HomeSidebar,
  HomeSidebarIntegrations,
  HomeSidebarNews,
  HomeSidebarUsage,
} from '~/components/home/HomeSidebar';
import {
  Account,
  AccountNotification,
  useHomePageQuery,
  User,
} from '~/generated/graphql';
import { useEntitlements } from '~/hooks/account';
import useOnboardingStatus from '~/hooks/account/useOnboardingStatus';

export const HomePage = () => {
  const { hasAccessEnrichment, hasAccessEnrichmentHubspot } = useEntitlements();
  const { hasConnectors, shouldOnboard } = useOnboardingStatus();
  const isOnboarding = shouldOnboard;

  const { data, loading } = useHomePageQuery();

  return (
    <>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <div className="w-full h-full @container/page ck-scrollbar ck-scrollbar--vertical">
        <div className="h-full min-w-0 min-h-0 bg-white @4xl/page:grid grid-cols-[1fr_25rem]">
          <div className="min-h-full ck-scrollbar ck-scrollbar--vertical">
            <CKLayoutGrid
              className="min-w-0 min-h-full p-8 space-y-12"
              gridTemplateRows="1fr auto"
            >
              <div className="min-h-0 space-y-12">
                <HomeHeader
                  account={data?.account as Account}
                  hasAccountIssue={!!data?.accountNotifications.length}
                  isOnboarding={isOnboarding}
                  user={data?.viewer.user as User}
                />
                <HomeSectionNotifications
                  accountConnectors={
                    data?.accountConnectors as Account['connectors']
                  }
                  notifications={
                    data?.accountNotifications as AccountNotification[]
                  }
                />
                {hasAccessEnrichmentHubspot ? <HomeSectionCompanies /> : null}
                {hasAccessEnrichmentHubspot ? <HomeSectionOnboarding /> : null}

                {!hasAccessEnrichmentHubspot ? (
                  <div className="relative space-y-12">
                    {!hasConnectors && hasAccessEnrichment ? (
                      <HomeBannerConnectCRM />
                    ) : null}
                    {!isOnboarding && !loading ? <BannerUpgradePlan /> : null}
                    {!loading ? <HomeSectionTimePeriod /> : null}
                  </div>
                ) : null}
              </div>
              <HomeFooter />
            </CKLayoutGrid>
          </div>
          <HomeSidebar>
            {!loading ? (
              <>
                <HomeSidebarUsage />
                <HomeSidebarIntegrations />
                <HomeSidebarNews news={data?.news} />
              </>
            ) : null}
          </HomeSidebar>
        </div>
      </div>
    </>
  );
};
